/**
 * Rank avatars — referenced through the bundler (08.10). Each file is emitted under
 * /_next/static/media with its content hash in the name and served
 * `immutable`: a browser fetches it once, until the file changes, which
 * changes its URL. `new URL(…, import.meta.url)` carries only the URL (an
 * image import would also inline a blur placeholder per file), and every file
 * is listed because the bundler ships only what it can see.
 */

/** The portraits a rank opens, keyed `rank-<rank>-<position>`. */
export const AVATAR_ART: Readonly<Record<string, string>> = {
  'rank-1-1': new URL('./rank-1-1.webp', import.meta.url).href,
  'rank-1-2': new URL('./rank-1-2.webp', import.meta.url).href,
  'rank-1-3': new URL('./rank-1-3.webp', import.meta.url).href,
  'rank-1-4': new URL('./rank-1-4.webp', import.meta.url).href,
  'rank-1-5': new URL('./rank-1-5.webp', import.meta.url).href,
  'rank-1-6': new URL('./rank-1-6.webp', import.meta.url).href,
  'rank-1-7': new URL('./rank-1-7.webp', import.meta.url).href,
  'rank-1-8': new URL('./rank-1-8.webp', import.meta.url).href,
  'rank-2-1': new URL('./rank-2-1.webp', import.meta.url).href,
  'rank-2-2': new URL('./rank-2-2.webp', import.meta.url).href,
  'rank-2-3': new URL('./rank-2-3.webp', import.meta.url).href,
  'rank-2-4': new URL('./rank-2-4.webp', import.meta.url).href,
  'rank-2-5': new URL('./rank-2-5.webp', import.meta.url).href,
  'rank-2-6': new URL('./rank-2-6.webp', import.meta.url).href,
  'rank-2-7': new URL('./rank-2-7.webp', import.meta.url).href,
  'rank-2-8': new URL('./rank-2-8.webp', import.meta.url).href,
  'rank-3-1': new URL('./rank-3-1.webp', import.meta.url).href,
  'rank-3-2': new URL('./rank-3-2.webp', import.meta.url).href,
  'rank-3-3': new URL('./rank-3-3.webp', import.meta.url).href,
  'rank-3-4': new URL('./rank-3-4.webp', import.meta.url).href,
  'rank-3-5': new URL('./rank-3-5.webp', import.meta.url).href,
  'rank-3-6': new URL('./rank-3-6.webp', import.meta.url).href,
  'rank-3-7': new URL('./rank-3-7.webp', import.meta.url).href,
  'rank-3-8': new URL('./rank-3-8.webp', import.meta.url).href,
  'rank-4-1': new URL('./rank-4-1.webp', import.meta.url).href,
  'rank-4-2': new URL('./rank-4-2.webp', import.meta.url).href,
  'rank-4-3': new URL('./rank-4-3.webp', import.meta.url).href,
  'rank-4-4': new URL('./rank-4-4.webp', import.meta.url).href,
  'rank-4-5': new URL('./rank-4-5.webp', import.meta.url).href,
  'rank-4-6': new URL('./rank-4-6.webp', import.meta.url).href,
  'rank-4-7': new URL('./rank-4-7.webp', import.meta.url).href,
  'rank-4-8': new URL('./rank-4-8.webp', import.meta.url).href,
  'rank-5-1': new URL('./rank-5-1.webp', import.meta.url).href,
  'rank-5-2': new URL('./rank-5-2.webp', import.meta.url).href,
  'rank-5-3': new URL('./rank-5-3.webp', import.meta.url).href,
  'rank-5-4': new URL('./rank-5-4.webp', import.meta.url).href,
  'rank-5-5': new URL('./rank-5-5.webp', import.meta.url).href,
  'rank-5-6': new URL('./rank-5-6.webp', import.meta.url).href,
  'rank-5-7': new URL('./rank-5-7.webp', import.meta.url).href,
  'rank-5-8': new URL('./rank-5-8.webp', import.meta.url).href,
  'rank-6-1': new URL('./rank-6-1.webp', import.meta.url).href,
  'rank-6-10': new URL('./rank-6-10.webp', import.meta.url).href,
  'rank-6-11': new URL('./rank-6-11.webp', import.meta.url).href,
  'rank-6-12': new URL('./rank-6-12.webp', import.meta.url).href,
  'rank-6-13': new URL('./rank-6-13.webp', import.meta.url).href,
  'rank-6-14': new URL('./rank-6-14.webp', import.meta.url).href,
  'rank-6-15': new URL('./rank-6-15.webp', import.meta.url).href,
  'rank-6-16': new URL('./rank-6-16.webp', import.meta.url).href,
  'rank-6-2': new URL('./rank-6-2.webp', import.meta.url).href,
  'rank-6-3': new URL('./rank-6-3.webp', import.meta.url).href,
  'rank-6-4': new URL('./rank-6-4.webp', import.meta.url).href,
  'rank-6-5': new URL('./rank-6-5.webp', import.meta.url).href,
  'rank-6-6': new URL('./rank-6-6.webp', import.meta.url).href,
  'rank-6-7': new URL('./rank-6-7.webp', import.meta.url).href,
  'rank-6-8': new URL('./rank-6-8.webp', import.meta.url).href,
  'rank-6-9': new URL('./rank-6-9.webp', import.meta.url).href,
};
